import { ACTION_TYPES } from "./types"
import { Proposal } from "../models"
import { ProposalEmailPayload } from "../services/types"

export const Action = {
    fetch: (id: string) => {
        return {
            type: ACTION_TYPES.FETCH,
            payload: id
        }
    },

    set: (payload: Proposal) => {
        return {
            type: ACTION_TYPES.SET,
            payload: payload,
        }
    },

    fetchSuccess: (payload: Proposal) => {
        return {
            type: ACTION_TYPES.FETCH_SUCCESS,
            payload: payload,
        }
    },

    sendByEmail: (proposalHash: string, payload: Partial<ProposalEmailPayload>) => {
        return {
            type: ACTION_TYPES.SEND_BY_EMAIL,
            payload: {
                proposalHash: proposalHash,
                ...payload,
            }
        }
    }
}






// WEBPACK FOOTER //
// ./src/state/proposal/actions/actions.ts